import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { ListItemWrapper, onDraggingStyle, ChildWrapper, showElement, TreeWrapper, InputWrapper } from './styled';
import SvgIcon from '../svg-icon/svg-icon';
import { Move, Cross, Expand, Collapse, Preview, Edit } from '../../helpers/icon-dictionary';
import Toggle from '../toggle/index';

class ListItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showChildren: this.props.isExpanded
        };
        this.isActionEvent = false;
    }

    componentWillReceiveProps(props) {
        this.setState({
            strand: props.strand,
            subStrand: props.subStrand
        });
    }

    showChildren = (e, id, status) => {
        this.setState({ showChildren: status });
        this.props.updateTopics(id, status);
        e.stopPropagation();
    }

    onToggle = (id, status) => {
        this.props.onToggle(id, status);
    }

    onNodeDelete = (id) => {
        this.props.onDelete(id);
        this.isActionEvent = true;
    }

    onListSelection = (id) => {
        if (id.indexOf('-') === -1 && !this.isActionEvent) {
            this.props.onItemSelect(id);
        }
        this.isActionEvent = false;
    }

    onEdit = (id, isSelected) => {
        this.isActionEvent = true;
        const modalInfo = {
            topicName: this.props.name
        };
        if (id.indexOf('-') === -1 && !isSelected) {
            this.props.onItemSelect(id);
        }
        this.props.handleOnEdit('edit', this.props.id, modalInfo);
    }

    renderListItem = (
        name,
        index,
        draggableId,
        showIconPanel,
        isEditable = false,
        showGirlIcons,
        isIncluded,
        previewUrl,
        isExpanded,
        isSelected = false,
        showDelete = false
    ) => {
        const { invalidStrands = [], invalidStandards = [] } = this.props;
        const styledProps = {
            draggableId,
            showGirlIcons,
            isInvalid: invalidStrands.includes(draggableId) || invalidStandards.includes(draggableId)
        };

        return (
            <Draggable draggableId={draggableId} index={index} key={draggableId}>{
                (provided, snapshot) => (
                    <ListItemWrapper
                        {...styledProps}
                        {...provided.draggableProps}
                        ref={provided.innerRef}
                    >
                        <div
                            className="info"
                            onClick={() => this.onListSelection(draggableId)}
                            role="button"
                            style={onDraggingStyle(snapshot.isDragging || isSelected)}
                            tabIndex={0}
                        >
                            <div className="moveIcon" {...provided.dragHandleProps}>
                                <SvgIcon icon={Move} />
                            </div>
                            <div className="name" style={showElement(isEditable)}>
                                <InputWrapper>
                                    <div
                                        className="icon"
                                        onClick={() => { this.onEdit(draggableId, isSelected); }}
                                        role="button"
                                        tabIndex="-1">
                                        <SvgIcon icon={Edit} />
                                    </div>
                                    <span
                                        id={draggableId}
                                        name={name}>
                                        {name}
                                    </span>
                                </InputWrapper>
                            </div>
                            <div className={showGirlIcons ? 'nameNonEditable' : 'name'} style={showElement(!isEditable)}>{name}</div>
                            <div className="iconPanel" style={showElement(showIconPanel)}>
                                <div className="iconStyle" onClick={() => this.onNodeDelete(draggableId)} role="button" style={showElement(showDelete)} tabIndex={0}>
                                    <SvgIcon icon={Cross} />
                                </div>
                                <div>
                                    <div className="iconStyle" onClick={e => this.showChildren(e, draggableId, false)} role="button" style={showElement(isExpanded)} tabIndex={0}><SvgIcon icon={Expand} /></div>
                                    <div className="iconStyle" onClick={e => this.showChildren(e, draggableId, true)} role="button" style={showElement(!isExpanded)} tabIndex={0}><SvgIcon icon={Collapse} /></div>
                                </div>
                            </div>
                            <div className="iconPanel" style={showElement(showGirlIcons)}>
                                <div className="previewStyle">
                                    <a href={previewUrl} rel="noopener noreferrer" target="_blank"> <SvgIcon icon={Preview} /> </a>
                                </div>
                                <div className="toggle">
                                    <Toggle onChange={status => this.onToggle(draggableId, status)} toggled={isIncluded} />
                                </div>
                            </div>
                        </div>
                    </ListItemWrapper>
                )
            }</Draggable>
        );
    }

    renderChildren = childNodes => childNodes.map((item, index) => {
        const key = index;
        const isGirlItem = item.groupName.indexOf('girl') !== -1;
        const isSpineItem = item.id.indexOf('spine') !== -1;

        return (
            <div className="node" key={key}>
                <ListItem
                    childNodes={item.childNodes}
                    childTopics={item.childTopics}
                    getTopicName={this.props.getTopicName}
                    handleOnEdit={this.props.handleOnEdit}
                    id={item.id}
                    index={index}
                    invalidStandards={this.props.invalidStandards}
                    invalidStrands={this.props.invalidStrands}
                    isEditable={item.isEditable}
                    isExpanded={isGirlItem ? false : item.isExpanded}
                    isIncluded={isGirlItem ? item.isIncluded : false}
                    isSelected={item.id.indexOf('-') === -1 ? item.isSelected : false}
                    name={item.name}
                    onDelete={this.onNodeDelete}
                    onItemSelect={this.onListSelection}
                    onToggle={this.onToggle}
                    previewUrl={isGirlItem ? item.previewUrl : ''}
                    showDelete={isSpineItem}
                    showGirlIcons={isGirlItem}
                    showIconPanel={!isGirlItem}
                    strand={this.props.strand}
                    subStrand={this.props.subStrand}
                    updateTopics={this.props.updateTopics}
                />
            </div>);
    })

    renderTree = (childNodes) => {
        if (childNodes && childNodes.length > 0) {
            return (
                <TreeWrapper className="tree">
                    <Droppable droppableId={childNodes[0].groupName} type={childNodes[0].groupName}>
                        {provided => (
                            <div
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                            >
                                {this.renderChildren(childNodes)}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </TreeWrapper>
            );
        }
        return null;
    };

    render() {
        const {
            name,
            index,
            id,
            childNodes,
            showIconPanel,
            isEditable,
            showGirlIcons,
            isIncluded,
            previewUrl,
            isExpanded,
            isSelected,
            showDelete,
            invalidStrands,
            invalidStandards
        } = this.props;
        let children;

        if (childNodes != null) {
            children = this.renderTree(childNodes);
        }
        return (
            <div>
                {this.renderListItem(
                    name,
                    index,
                    id,
                    showIconPanel,
                    isEditable,
                    showGirlIcons,
                    isIncluded,
                    previewUrl,
                    isExpanded,
                    isSelected,
                    showDelete,
                    invalidStrands,
                    invalidStandards
                )}
                {isExpanded && (
                    <ChildWrapper className="childPanel">
                        {children}
                    </ChildWrapper>
                )}
            </div>
        );
    }
}

ListItem.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    previewUrl: PropTypes.string,
    index: PropTypes.number,
    childNodes: PropTypes.array,
    childTopics: PropTypes.array,
    showDelete: PropTypes.bool,
    showIconPanel: PropTypes.bool,
    showGirlIcons: PropTypes.bool,
    isEditable: PropTypes.bool,
    isIncluded: PropTypes.bool,
    // Array of strand ids which have Steps without spine nodes. We highlight these with red border
    invalidStrands: PropTypes.array,
    invalidStandards: PropTypes.array,
    isExpanded: PropTypes.bool,
    isSelected: PropTypes.bool,
    getTopicName: PropTypes.func,
    onToggle: PropTypes.func,
    onItemSelect: PropTypes.func,
    updateTopics: PropTypes.func,
    handleOnEdit: PropTypes.func,
    strand: PropTypes.string,
    subStrand: PropTypes.string,
    onDelete: PropTypes.func
};

export default injectIntl(ListItem);



// WEBPACK FOOTER //
// ./app/components/list-item/index.js